import { InteractiveTable } from '@dreryk/react-components';

import { serviceSettingsTranslationKeys } from '../../../../../translations';
import { addEmptyRow } from '../TimeBasedRefundInteractiveTable.utils';

const t = serviceSettingsTranslationKeys.advancePayments.form.timeBasedRefundInteractiveTable.buttons;

export const TimeBasedRefundAddRow = (): JSX.Element => {
   return <InteractiveTable.AddRowButton label={t.addRow} onAddRow={addEmptyRow} behavior={'append'} />;
};
